import React from 'react';
import { Spin, Typography } from 'antd';
import { useTranslate } from '@refinedev/core';
import { useDiagramImage } from '../../hooks/useDiagramImage';

/** The diagram the API draws from the UML text; if it cannot be drawn, what the person wrote, as text. */
export const DiagramImage = ({
  source,
  testId,
  style,
  fallbackLines = [],
}: {
  source: string;
  testId?: string;
  style?: React.CSSProperties;
  fallbackLines?: string[];
}) => {
  const translate = useTranslate();
  const { uri, loading, error } = useDiagramImage(source);

  if (uri) {
    return <img data-testid={testId} src={uri} alt={translate('diagram.alt')} style={style} />;
  }
  if (error) {
    return (
      <div data-testid={testId ? `${testId}-fallback` : undefined}>
        <Typography.Text type="secondary">{translate('diagram.unavailable')}</Typography.Text>
        <ul>
          {fallbackLines.filter(Boolean).map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      </div>
    );
  }
  return loading ? <Spin data-testid={testId ? `${testId}-loading` : undefined} /> : null;
};
